import { INTERNAL_ROUTES } from '@/constants/urls';

/**
 * Whether an advertising partner's script may run on the page the browser shows
 * right now. The Meta Pixel and Tapad read the current URL themselves, and an
 * opt-in can come after the landing page has moved on (the desktop redirect to
 * /chat, or the voter opening Settings), so a deferred event checks the URL it
 * would be read from. The landing URL itself always qualifies; otherwise only
 * screens whose URL carries no identifier do, unlike `/chat/<conversation id>`.
 */
const REPORTABLE_PATHS = new Set([
  '/',
  INTERNAL_ROUTES.CHAT,
  INTERNAL_ROUTES.SETTINGS,
  INTERNAL_ROUTES.HELP,
]);
// `campaign` is VoteMate's own campaign code (`?campaign=`, see App.tsx), distinct
// from the `utm_campaign` tag.
const REPORTABLE_QUERY_KEY = /^(utm_(source|medium|campaign|term|content)|guest|section|campaign)$/;

// `partnerKeys` admits a partner's own click identifiers (e.g. Google's `gclid`),
// which only go back to the partner that issued them.
export const isReportableUrl = (
  href: string,
  landingHref: string,
  partnerKeys: ReadonlySet<string> = new Set()
): boolean => {
  if (href === landingHref) return true;
  try {
    const url = new URL(href);
    if (url.hash || !REPORTABLE_PATHS.has(url.pathname)) return false;
    for (const key of url.searchParams.keys()) {
      if (!REPORTABLE_QUERY_KEY.test(key) && !partnerKeys.has(key)) return false;
    }
    return true;
  } catch {
    return false;
  }
};
